import svgUrl from "ni:svgr;OEnJD6SUffbxoB3vukotkYpN3nGbg41Ir7jUKKWmoIE";
export default svgUrl;
import * as React from "react";
import { memo } from "react";
const UiUnionSIcon = props => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M13 3H3v3h10V3ZM3 2a1 1 0 0 0-1 1v4h5v2H2v4a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1H9V7h5V3a1 1 0 0 0-1-1H3Zm10 8H3v3h10v-3Z" clipRule="evenodd" /></svg>;
const Memo = memo(UiUnionSIcon);
export { Memo as ReactComponent };
if (import.meta.env.DEV) {
  Memo.displayName = "ui-node-icon(UiUnionSIcon)";
}